import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { DragHandleIcon } from '../../../Icons';
import { useAllRoles } from '../../../../../context/RoleContext';
import { generateRolesName } from '../../helpers/utils';

export function ClinicianItem(props) {
  const { user } = props;
  const { tenancyRoles } = useAllRoles();
  const roles = user?.roles ? generateRolesName(user.roles, tenancyRoles) : '';
  return (
    <div key={user.clinicianId} className="space-between">
      <div>
        {props.enabledDrag ? (
          <DragHandleIcon className="me-1" size={20} />
        ) : (
          <div
            style={{
              width: '20px',
              marginRight: '8px',
            }}
          />
        )}
        <span className="team-member-name">{`${user.firstName} ${user.lastName}`}</span>
        <span className="team-member-role"> {`${roles}`}</span>
      </div>
      <div style={{ color: '#5b6366' }}>
        <i>{user.patientOnList} pts on list</i>
      </div>
    </div>
  );
}

export default function SortableItem(props) {
  const { enabledDrag } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id, data: props.user, disabled: !enabledDrag });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: '90%',
  };

  return (
    <div
      {...props}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <ClinicianItem
        user={props.user}
        id={props.id}
        enabledDrag={props.enabledDrag}
      />{' '}
    </div>
  );
}
